module.exports = __webpack_public_path__ + "img/honour-pic-12.bb93a2ec.png";